import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const NewsletterForm = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("You're in. Trip drops coming your way.");
      setEmail("");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="newsletter-form" className="flex flex-wrap gap-2">
      <Input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        data-testid="newsletter-email-input"
        placeholder="you@email.com"
        className="rounded-none h-12 bg-transparent border-cream/30 text-cream placeholder:text-cream/40 focus-visible:ring-flame flex-1 min-w-0"
      />
      <Button
        type="submit"
        disabled={loading}
        data-testid="newsletter-submit-btn"
        className="rounded-none h-12 bg-flame hover:bg-flame/90 text-white font-bold uppercase tracking-widest text-xs px-6 shrink-0"
      >
        {loading ? "..." : "Sign Up"}
      </Button>
    </form>
  );
};
